export const RTDB_RESUME_RECONNECT_AFTER_MS = 15_000;

export function shouldReconnectAfterResume(inactiveSince, now = Date.now()) {
  const startedAt = Number(inactiveSince || 0);
  const resumedAt = Number(now || 0);
  return (
    Number.isFinite(startedAt) &&
    Number.isFinite(resumedAt) &&
    startedAt > 0 &&
    resumedAt >= startedAt &&
    resumedAt - startedAt >= RTDB_RESUME_RECONNECT_AFTER_MS
  );
}
